import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledBoxDriverAckConfirmationModal = styled(Box)(() => ({
  backgroundColor: '#fff'
}));

export const StyledPullerDriverAckConfirmationModal = styled(Box)(() => ({
  width: '40px',
  height: '4px',
  backgroundColor: '#E5E5E5',
  borderRadius: '4px',
  position: 'absolute',
  top: '20px',
  left: 'calc(50% - 20px)'
}));
